import axios, { AxiosError } from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import AjouterProduit from "../../Views/Admin/categories/AjouterProduit";
import AjouterCommercial from "../../Views/Magasin/commercial/AjouterCommercial";

export default function AddCommercialMagasin(){
    const navigate = useNavigate();
    const [Nom, setNom] = useState<string>("");
    const [Prénom, setPrénom] = useState<string>("");
    const [Télephone, setTélephone] = useState<string>("");
    const [Ville, setVille] = useState<string>("");
    const [MessageError, setMessageError] = useState<string>("");
    const [RemiseGlobale, setRemiseGlobale] = useState<string>("");
    const [Credit, setCredit] = useState<string>("");
    const [Cin, setCin] = useState<string>("");
    const [Email, setEmail] = useState<string>("");
    const [Password, setPassword] = useState<string>("");
    const [showSuccessPopup, setShowSuccessPopup] = useState<boolean>(false);
    const [showErrorPopup, setShowErrorPopup] = useState<boolean>(false);
    const MagasinId = localStorage.getItem('MagasinId');
    const MagasinName = localStorage.getItem('MagasinName');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!Nom || !Prénom || !Télephone || !Ville || !Cin) {
      setMessageError("Veuillez saisir toutes les informations : nom, prénom, téléphone, ville et CIN sont obligatoires.");
      setShowErrorPopup(true);
      setTimeout(() => {
        setMessageError("");
        setShowErrorPopup(false);
      }, 3000);
      return;
    }

    if (Cin.trim().length !== 8) {
      setMessageError("Le CIN est obligatoire et doit contenir exactement 8 caractères.");
      setShowErrorPopup(true);
      setTimeout(() => {
        setMessageError("");
        setShowErrorPopup(false);
      }, 3000);
      return;
    }

    const formData = new FormData();
    formData.append("nom", Nom);
    formData.append("MagasinName", MagasinName?MagasinName:"");
    formData.append("prenom", Prénom);
    formData.append("Tele", Télephone);
    formData.append("ville", Ville);
    formData.append("Credit", Credit || "0");
    formData.append("Cin", Cin);
    formData.append("RemiseGlobal", RemiseGlobale || "0");
    formData.append("email", Email);
    formData.append("password", Password);
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${MagasinId}/commercial/add`, formData)
      .then(({data})=>{
            if(data === "This commercial is already associated with this magasin."){
              // Case: email exists and commercial is already linked to this magasin
              setMessageError("Ce commercial est déjà associé à ce magasin.");
              setShowErrorPopup(true);
              setTimeout(() => {
                setMessageError('');
                setShowErrorPopup(false);
              }, 3000);
            }else{
              // Case: new commercial created OR existing commercial linked to new magasin
              setShowSuccessPopup(true);
    
              const timeoutId = setTimeout(() => {
                setShowSuccessPopup(false);
                navigate(`/magasins/${MagasinId}/commercials`);
              }, 2000);
            }
      });
    } catch (error: AxiosError | any) {
        setMessageError('Veuillez saisir toutes les informations obligatoires.');
        setShowErrorPopup(true);
        const timeoutId = setTimeout(() => {
        setMessageError('');
        setShowErrorPopup(false);
        }, 3000);

      } 
      
    }
  return <>
  <AjouterCommercial
  Nom={Nom}
  Prenom = {Prénom}
  showSuccessPopup={showSuccessPopup}
  setShowSuccessPopup={setShowSuccessPopup}
  showErrorPopup={showErrorPopup}
  setShowErrorPopup={setShowErrorPopup}
  Credit={Credit}
  setCredit={setCredit}
  Cin={Cin}
  setCin={setCin}
  RemiseGlobal={RemiseGlobale}
  Tele={Télephone}
  Ville={Ville}
  setPrénom={setPrénom}
  setNom={setNom}
  setTélephone={setTélephone}
  setVille={setVille}
  setRemiseGlobale={setRemiseGlobale}
  setEmail={setEmail}
  setPassword={setPassword}
  handleSubmit={handleSubmit}
  MessageError={MessageError}
  setMessageError={setMessageError}

  />
  </>;
}